export const AUDIO_ACTIVITY_MIN_PERCEIVED_VOLUME = 0.035;

export function calculateRawAudioVolume(levels) {
  let sum = 0;

  for (let i = 0; i < levels.length; i++) {
    const amplitude = (levels[i] - 128) / 128;
    sum += amplitude * amplitude;
  }

  return Math.sqrt(sum / levels.length);
}

export function calculatePerceivedAudioVolume(rawVolume) {
  return Math.log(1 + rawVolume * (Math.E - 1));
}

export function calculateAudioActivityVolume(levels, minPerceivedVolume = AUDIO_ACTIVITY_MIN_PERCEIVED_VOLUME) {
  const perceivedVolume = calculatePerceivedAudioVolume(calculateRawAudioVolume(levels));

  return perceivedVolume < minPerceivedVolume ? 0 : perceivedVolume;
}

export function updateSmoothedAudioActivityVolume(target, nextVolume) {
  const smoothing = nextVolume > target.prevVolume ? 0.35 : 0.3;

  target.volume = smoothing * nextVolume + (1 - smoothing) * target.prevVolume;
  target.prevVolume = target.volume;

  return target.volume;
}
